/**
 * @generated SignedSource<<66b9ef7877cbdd887237669e6adf97db>>
 * @relayHash 155826397e5face6a52654a38f536041
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 896f8b4074c02c6c9d0deb9acb06af14bc9a48d13639781e0aa64bb0f7ac43ca

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ui_JsmStandardToPremiumModalQuery$variables = {
  cloudId: string;
  isCollectionEnabled: boolean;
  productKey: string;
};
export type ui_JsmStandardToPremiumModalQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement?: {
        readonly relatesFromEntitlements?: ReadonlyArray<{
          readonly relationshipType: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type ui_JsmStandardToPremiumModalQuery = {
  response: ui_JsmStandardToPremiumModalQuery$data;
  variables: ui_JsmStandardToPremiumModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCollectionEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v3 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "CcpEntitlementRelationship",
      "kind": "LinkedField",
      "name": "relatesFromEntitlements",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "relationshipType"
        }
      ]
    }
  ],
  "type": "CcpEntitlement"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_JsmStandardToPremiumModalQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "condition": "isCollectionEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ui_JsmStandardToPremiumModalQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "condition": "isCollectionEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "896f8b4074c02c6c9d0deb9acb06af14bc9a48d13639781e0aa64bb0f7ac43ca",
    "metadata": {},
    "name": "ui_JsmStandardToPremiumModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "90e4cf77530196f3298c539031a56d18";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
